<div class="edit-details-container d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center">
        <span class="edit-details-text">Alert Message !</span>
        <div class="img-container" mat-dialog-close>
            <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
        </div>
    </div>


    <div class="d-flex flex-column">
        <label class="search-text"> Are you sure you want to mark this defaulter as 'Expired'</label>


    </div>

    <button class="dp-primary-btn save-btn" (click)="onYesClick()">Yes, expired</button>
    <button class="dp-destructive-btn save-btn" (click)="onNoClick()">No, cancel</button>

</div>